














// Importing components
import BaseNavigation from '@/base/BaseNavigation.vue';
import BaseFooter from '@/base/BaseFooter.vue';

export default {
    name: 'LayoutMain',
    components: {
        BaseNavigation,
        BaseFooter,
    },
    props: {},
    data() {
        return {};
    },
    methods: {},
};
